export default "__VITE_ASSET___Sdgowom__"